import { withStyles } from "@material-ui/core";
import React from "react";
import { formatPhone } from "../../../../../utils/utils";
import Detail from "./Detail";
import styles from "../styles";

const index = ({ classes, data }) => {
  return (
    <div className={classes.infoContainer}>
      <Detail title="Account #:" value={data.shipperAccountNumber} />
      <Detail title="Account Name:" value={data.shipperName} />
      <Detail title="Contact #:" value={formatPhone(data.shipperPhoneNumber)} />
      <Detail title="Email #:" value={data.shipperEmail} />
      <Detail title="Address1:" value={data.shipperAddress1} />
      <Detail title="Address2:" value={data.shipperAddress2} />
      <Detail title="City:" value={data.shipperCity} />
      <Detail title="State:" value={data.shipperState} />
      <Detail title="Zip Code:" value={data.shipperZip} />
      <Detail title="Reference #:" value={data.pickupReferenceNumber} />
      <Detail title="Credit:" value={data.creditType} />
    </div>
  );
};

export default withStyles(styles)(index);
